module.exports = __webpack_public_path__ + "static/img/btn_9_1.b50b88a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/btn_9_1.png
// module id = lGk0
// module chunks = 0